'use client';

import React from 'react';
import { X, Linkedin, MessageSquare, CalendarPlus, Trash2, Tag } from 'lucide-react';
import { toast } from 'sonner';
import Icon from '@/components/ui/AppIcon';


interface Props {
  count: number;
  onClear: () => void;
}

export default function ContactsBulkBar({ count, onClear }: Props) {
  return (
    <div className="sticky top-0 z-20 mx-6 mt-3 flex items-center gap-3 px-4 py-3 bg-primary text-white rounded-xl shadow-dropdown slide-up">
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold font-mono">{count}</span>
        <span className="text-sm text-white/80">contacts selected</span>
      </div>
      <div className="h-4 w-px bg-white/30 mx-1" />
      <div className="flex items-center gap-1.5">
        <BulkAction
          icon={Linkedin}
          label="Send LinkedIn"
          onClick={() => toast.success(`LinkedIn action queued for ${count} contacts`)}
        />
        <BulkAction
          icon={MessageSquare}
          label="Send Message"
          onClick={() => toast.success(`Message drafted for ${count} contacts`)}
        />
        <BulkAction
          icon={CalendarPlus}
          label="Request Meeting"
          onClick={() => toast.success(`Meeting request created for ${count} contacts`)}
        />
        <BulkAction
          icon={Tag}
          label="Add Tag"
          onClick={() => toast.info(`Tag panel — ${count} contacts`)}
        />
        <BulkAction
          icon={Trash2}
          label="Delete"
          onClick={() => toast.error(`Delete ${count} contacts?`, { action: { label: 'Confirm', onClick: () => toast.success('Deleted') } })}
          danger
        />
      </div>
      <button
        onClick={onClear}
        className="ml-auto p-1.5 rounded-lg hover:bg-white/20 transition-colors"
        aria-label="Clear selection"
      >
        <X size={15} />
      </button>
    </div>
  );
}

function BulkAction({
  icon: Icon, label, onClick, danger,
}: {
  icon: React.ElementType;
  label: string;
  onClick: () => void;
  danger?: boolean;
}) {
  return (
    <button
      onClick={onClick}
      title={label}
      className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-colors ${
        danger
          ? 'hover:bg-red-500/30 text-red-200 hover:text-white' :'hover:bg-white/20 text-white/90 hover:text-white'
      }`}
    >
      <Icon size={13} />
      <span className="hidden sm:inline">{label}</span>
    </button>
  );
}